
// Import necessary dependencies
import { supabase } from '@/integrations/supabase/client';
import { Product } from '@/lib/types';
import { transformRemoteToProduct, transformProductToRemote } from './transformers';
import { PRODUCTS_TABLE, getUserId } from './api-utils';

export const addProductToApi = async (product: Product): Promise<Product> => {
  try {
    console.log('Adding product to API:', product.name);
    console.log('Product ID (should be UUID format):', product.id);
    
    const userId = await getUserId();
    
    const remoteProduct = transformProductToRemote(product, userId);
    console.log('Transformed product for Supabase:', remoteProduct);
    
    // Insert the product
    const { data, error } = await supabase
      .from(PRODUCTS_TABLE)
      .insert(remoteProduct)
      .select()
      .single();
    
    if (error) {
      console.error('Error adding product:', error);
      throw error;
    }
    
    console.log('Product added successfully:', data.name);
    
    // Handle product-group relationships
    if (product.groupIds && product.groupIds.length > 0) {
      try {
        console.log(`Adding ${product.groupIds.length} group relationships for product ${data.id}`);
        
        const groupRelations = product.groupIds.map(groupId => ({
          product_id: data.id, // Use the ID from the inserted product
          group_id: groupId
        }));
        
        const { error: groupError } = await supabase
          .from('product_groups')
          .insert(groupRelations);
          
        if (groupError) {
          console.error('Error adding product-group relationships:', groupError);
          // Continue anyway, just log the error
        } else {
          console.log('Product-group relationships added successfully');
        }
      } catch (groupError) {
        console.error('Error in product-group relationship creation:', groupError);
        // Continue anyway, just log the error
      }
    }
    
    // Return the complete product with groupIds
    const result = transformRemoteToProduct(data);
    result.groupIds = product.groupIds || [];
    return result;
  } catch (error) {
    console.error('Error in addProductToApi:', error);
    throw error;
  }
};
